import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes';

const PaymentDelayedSummary = ({ partner }) => (
    <StatusSummaryButton
        href="/utsatt-betaling"
        statusSummary="Utbetalingen til deg er utsatt."
        actionRequiredType="NEGATIVE"
    >
        {partner.name} har ikke fått varen
    </StatusSummaryButton>
);

PaymentDelayedSummary.propTypes = {
    partner: partnerPropTypes.isRequired,
};

export default PaymentDelayedSummary;



// WEBPACK FOOTER //
// ./safeTrade/seller/resolution/summaries/paymentDelayedSummary.jsx